import { BudgetOrRatioCarbonFilterComponent } from './../../budget-or-ratio-carbon-filter/budget-or-ratio-carbon-filter.component';
import { BudgetOrRatioFilterComponent } from './../../budget-or-ratio-filter/budget-or-ratio-filter.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { KPI } from '../../../../@core/api';
import { map, Observable, of, Subscription } from 'rxjs';
import { ChartFiltersService, ConfigService, InvestmentScenariiService } from '../../../../@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { NbAccordionModule, NbTabsetModule } from '@nebular/theme';
import { InvestmentsSpreadsheetComponent } from '../../investments-spreadsheet/investments-spreadsheet.component';
import { InitiativesSpreadsheetComponent } from '../../initiatives-spreadsheet/initiatives-spreadsheet.component';
import { AsyncPipe } from '@angular/common';
import { EnergyTrajectoryChartComponent } from '../../charts/energy-trajectory-chart/energy-trajectory-chart.component';
import { EnergyOrCarbonTrajectoryFilterComponent } from '../../energy-or-carbon-trajectory-filter/energy-or-carbon-trajectory-filter.component';
import { CarbonTrajectoryChartComponent } from '../../charts/carbon-trajectory-chart/carbon-trajectory-chart.component';
import { AgGridProjectComponent } from "../../ag-grid-project/ag-grid-project.component";
import { BuildingSelectorComponent } from '../../building-selector/building-selector.component';
import { ScenariiSelectorComponent } from '../../scenarii-selector/scenarii-selector.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-rse-energy-carbon-prevision',
    templateUrl: './rse-energy-carbon-prevision.component.html',
    styleUrls: ['./rse-energy-carbon-prevision.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
      NbAccordionModule,
      TranslateModule,
      NbTabsetModule,
      InvestmentsSpreadsheetComponent,
      InitiativesSpreadsheetComponent,
      EnergyTrajectoryChartComponent,
      BudgetOrRatioFilterComponent,
      EnergyOrCarbonTrajectoryFilterComponent,
      BudgetOrRatioCarbonFilterComponent,
      CarbonTrajectoryChartComponent,
      AsyncPipe,
      AgGridProjectComponent,
      BuildingSelectorComponent,
      ScenariiSelectorComponent,
  ],
})
export class RseEnergyCarbonPrevisionComponent implements OnInit, OnChanges, OnDestroy {

  public selectedTabId: number = 1;
  public isFidjiAct$: Observable<boolean> = of(false);
  public showInitiatives: boolean = false;
  public showInvestments: boolean = false;
  public showProjects: boolean = false;

  constructor(
    private investmentScenariiService: InvestmentScenariiService,
    private cdRef: ChangeDetectorRef,
    private chartFiltersService: ChartFiltersService,
    private configService: ConfigService,
    private route: ActivatedRoute,
  ) { }

  @Input() perimeter: KPI.Perimeter

  private subscriptions: Subscription[] = [];
  public scenario: KPI.InvestmentScenario;
  public tablesFilter: any;
  public projectsEnabled: boolean = false;

  public selectedBuildingIds: number[] = [];

  public displayEnergyChart$: Observable<boolean> = this.chartFiltersService.filter$('energyOrCarbonTrajectory').pipe(
    map(filter => filter === KPI.EnergyOrCarbonTrajectoryFilter.ENERGY),
  );

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.paramMap.subscribe(() => {
        this.refreshData();
      }),
      this.route.queryParams.subscribe(() => {
        this.refreshData();
      })
    );
    const tabsConfig = this.configService.getSettingValue('ENERGY__TRAJECTORY_TABS', []);
    this.showInitiatives = tabsConfig?.includes('ACTION_TABLE');
    this.showInvestments = tabsConfig?.includes('INVESTMENT_TABLE');
    this.showProjects = tabsConfig?.includes('PROJECT_TABLE');
  }

  ngOnChanges(): void {
    this.refreshData();
  }

  private refreshData(): void {
    if (this.perimeter) {
      this.tablesFilter = {
        site: [this.perimeter.id],
      };

      this.subscriptions.push(
        this.investmentScenariiService.mainScenario$.subscribe((mainScenario) => {
          this.scenario = mainScenario;
          this.cdRef.detectChanges();
        }),
      );
    }
  }

  public onBuildingSelectionChanged(buildingIds: number[]): void {
    this.selectedBuildingIds = buildingIds;
  }

  public changeTab(event): void {
    this.selectedTabId = Number(event.tabId);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

}
